import React from 'react';
import SafeIcon from '../../../common/SafeIcon';

export default function CamperPreview({ type, data }) {
  return (
    <div className="border-2 border-dashed border-gray-300 rounded-md p-4 bg-cream shadow-sm relative sticky top-4">
      <div className="absolute top-0 right-0 bg-gray-800 text-white text-[10px] uppercase font-bold px-3 py-1 rounded-bl-md z-10">
        Camper View
      </div>
      
      {type === 'assembly' && (
        <div className="space-y-4 mt-4">
          <div className="bg-[#EAF1E6] border-l-4 p-3 rounded-r-md" style={{ borderColor: data.badge_color || '#2D5016' }}>
            <h1 className="text-lg font-bold text-dark-green flex items-center gap-2">
              <SafeIcon name="Video" /> Morning Assembly
            </h1>
          </div>
          
          <div>
            <h2 className="font-bold text-dark-green">{data.day_title || 'Day Title'}</h2>
            <div className="text-xs text-forest-green font-semibold uppercase mb-2">{data.persona_label || 'Persona'}</div>
          </div>

          <div className="bg-black aspect-video w-full flex items-center justify-center text-white/50 text-sm overflow-hidden relative rounded-md">
            {data.video_embed ? (
              <div 
                className="w-full h-full pointer-events-none absolute inset-0 [&>iframe]:w-full [&>iframe]:h-full border-0" 
                dangerouslySetInnerHTML={{ __html: data.video_embed }} 
              />
            ) : data.video_url ? (
              <iframe src={data.video_url} className="w-full h-full pointer-events-none absolute inset-0 border-0" title="Preview" />
            ) : 'Video Player'}
          </div>
          
          <p className="text-sm text-muted line-clamp-3">{data.intro_text || 'Intro paragraph...'}</p>
          
          {(data.product_headline || data.product_image_url || data.product_url) && (
            <div className="bg-[#F1F6FE] p-4 rounded border-2 border-[#DA7D3A] mt-4 flex flex-col sm:flex-row gap-4 items-center">
              {data.product_image_url && (
                <div className="w-full sm:w-1/2 flex justify-center">
                  <img src={data.product_image_url} alt="Product" className="w-full h-auto rounded shadow-sm" />
                </div>
              )}
              <div className={`w-full ${data.product_image_url ? 'sm:w-1/2' : ''} text-center sm:text-left`}>
                <div className="text-sm font-bold text-dark-green mb-1">{data.product_headline || 'Product Headline'}</div>
                {data.product_description && (
                  <p className="text-[11px] text-gray-600 mb-2 leading-tight">{data.product_description}</p>
                )}
                <button className="bg-amber text-white text-[10px] px-3 py-1.5 rounded mt-1 shadow-sm">
                  {data.product_button_text || 'Grab It Now'}
                </button>
              </div>
            </div>
          )}

          {/* Bonus Videos Preview */}
          {(() => {
            let bVideos = [];
            try {
              bVideos = JSON.parse(data.bonus_videos || '[]');
              bVideos = Array.isArray(bVideos) ? bVideos : [];
            } catch(e) {}
            
            if (bVideos.length === 0) return null;

            return (
              <div className="mt-4 space-y-3 pt-4 border-t border-tan">
                <h3 className="text-sm font-bold text-dark-green flex items-center gap-1">
                  <SafeIcon name="PlayCircle" className="text-amber text-xs" /> Bonus Content
                </h3>
                {bVideos.map((v, i) => (
                  <div key={i} className="bg-gray-50 rounded p-2 border border-gray-200">
                    <div className="aspect-video bg-black rounded overflow-hidden relative shadow-inner mb-2">
                      {v.embed ? (
                        <div 
                          className="w-full h-full pointer-events-none absolute inset-0 [&>iframe]:w-full [&>iframe]:h-full border-0" 
                          dangerouslySetInnerHTML={{ __html: v.embed }} 
                        />
                      ) : v.url ? (
                        <iframe src={v.url} className="w-full h-full pointer-events-none absolute inset-0 border-0" title="Preview" />
                      ) : (
                        <div className="flex flex-col items-center justify-center h-full text-white/50">
                          <SafeIcon name="Video" className="text-xl mb-1" />
                        </div>
                      )}
                    </div>
                    {v.description && <p className="text-xs text-gray-600 line-clamp-2">{v.description}</p>}
                  </div>
                ))}
              </div>
            );
          })()}
        </div>
      )}

      {type === 'messhall' && (
        <div className="space-y-4 mt-4">
          <div className="bg-[#EAF1E6] border-l-4 border-forest-green p-3 rounded-r-md">
            <h1 className="text-lg font-bold text-dark-green flex items-center gap-2">
              <SafeIcon name="Users" /> Midday Mess Hall
            </h1>
          </div>
          
          <div>
            <h2 className="font-bold text-dark-green">{data.session_title || 'Session Title'}</h2>
          </div>

          <div className="bg-[#2A2A2A] aspect-video w-full flex items-center justify-center text-white/50 text-sm overflow-hidden rounded-md relative">
            {data.video_embed ? (
               <div 
                 className="w-full h-full pointer-events-none absolute inset-0 [&>iframe]:w-full [&>iframe]:h-full border-0" 
                 dangerouslySetInnerHTML={{ __html: data.video_embed }} 
               />
            ) : data.video_url ? (
               <iframe src={data.video_url} className="w-full h-full pointer-events-none absolute inset-0 border-0" title="Preview" />
            ) : (
               <div className="flex flex-col items-center">
                 <SafeIcon name="Clock" className="text-xl mb-1" />
                 <span className="text-[10px]">Replay Placeholder</span>
               </div>
            )}
          </div>

          <p className="text-xs text-muted mt-1">{data.session_description || 'Session description...'}</p>
          
          {!data.video_url && !data.video_embed && (
            <div className="bg-white p-4 rounded-md border border-gray-200 text-center shadow-sm">
              <SafeIcon name="Video" className="text-3xl text-gwa-blue mx-auto mb-2" />
              <button className="mt-2 bg-forest-green text-white text-xs px-4 py-2 rounded pointer-events-none">Join Meetn Room</button>
            </div>
          )}
          
          <div className="bg-amber/10 p-4 border border-amber/30 rounded-md">
            <h3 className="text-sm font-bold text-dark-green flex items-center gap-1 mb-1">
              <SafeIcon name="MessageSquare" className="text-amber text-xs" /> Today's Prompt
            </h3>
            <p className="text-xs italic text-dark-green">{data.checkin_prompt || 'Prompt goes here...'}</p>
          </div>
        </div>
      )}

      {type === 'cabincall' && (
        <div className="space-y-4 mt-4">
          <div className="bg-[#EAF1E6] border-l-4 border-forest-green p-3 rounded-r-md">
            <h1 className="text-lg font-bold text-dark-green flex items-center gap-2">
              <SafeIcon name="BookOpen" /> Cabin Call
            </h1>
          </div>
          <h2 className="font-bold text-dark-green">{data.section_title || 'Section Title'}</h2>
          <p className="text-sm text-muted">{data.opening_paragraph || 'Opening framed paragraph...'}</p>
          
          <div className="space-y-3">
            {(() => {
              let prompts = [];
              try { 
                prompts = JSON.parse(data.compass_prompts || '[]'); 
              } catch(e) {
                console.warn("Failed to parse prompts in preview", e);
              }
              
              if (prompts.length === 0) return <div className="text-xs text-gray-400 border border-dashed p-4 text-center">No prompts added</div>;
              
              return prompts.map((p, i) => (
                <div key={i} className="text-sm">
                  <div className="font-medium text-dark-green mb-1">{p.label || 'Question?'}</div>
                  {p.type === 'Long text' && <div className="h-16 bg-white border border-gray-200 rounded"></div>}
                  {p.type === 'Short text' && <div className="h-8 bg-white border border-gray-200 rounded"></div>}
                  {(p.type === 'Radio select' || p.type === 'Checkbox group') && (
                    <div className="flex gap-2"><div className="w-4 h-4 rounded-full border border-gray-300"></div><div className="w-1/2 h-4 bg-gray-200 rounded"></div></div>
                  )}
                  {p.callout_text && (
                    <div className="mt-2 bg-cream p-2 border border-amber text-xs rounded">
                      <strong>{p.callout_label}:</strong> {p.callout_text}
                    </div>
                  )}
                </div>
              ));
            })()}
          </div>
        </div>
      )}

      {type === 'campfire' && (
        <div className="space-y-4 mt-4">
          <div className="bg-[#EAF1E6] border-l-4 border-forest-green p-3 rounded-r-md">
            <h1 className="text-lg font-bold text-dark-green flex items-center gap-2">
              <SafeIcon name="Flame" className="text-amber" /> Evening Campfire
            </h1>
          </div>
          <div className="bg-white border border-tan text-center p-6 rounded-md shadow-sm">
            <SafeIcon name="Flame" className="text-4xl text-amber mx-auto mb-3" />
            <p className="text-forest-green font-medium text-sm italic mb-4">"{data.prompt || 'Reflection prompt...'}"</p>
            {data.encouragement_note && (
              <div className="mt-4 border-t border-tan pt-4 text-left space-y-2">
                {(data.encouragement_note || '').split('\n\n').map((p, idx) => (
                  <p key={idx} className="text-xs text-dark-green whitespace-pre-wrap">{p}</p>
                ))}
              </div>
            )}
            <button className="bg-[#1877F2] text-white text-xs px-4 py-2 rounded pointer-events-none flex items-center justify-center gap-2 mx-auto mt-4 w-full">
              <SafeIcon name="Facebook" /> Share in Group
            </button>
          </div>
        </div>
      )}
    </div>
  );
}